import styled from 'styled-components';

import FluidItemGrid, { GridBreakpoints } from '@/components/GridItemCard/FluidItemGrid/FluidItemGrid';
import { mergedCaterwaulAndHammerUIThemes as theme } from '@/theme/mergedCaterwaulAndHammerUIThemes';

export const gridBreakpointsPast: GridBreakpoints = {
    breakpoints: {
        [theme.breakpoints.lgMinValue]: {
            column: 6,
            gap: {
                column: theme.spacing.mdValue,
                row: theme.spacing.lgValue,
            },
        },
        [theme.breakpoints.smMinValue]: {
            column: 4,
            gap: {
                column: theme.spacing.mdValue,
                row: theme.spacing.lgValue,
            },
        },
    },
    column: 1,
    gap: {
        column: theme.spacing.smValue,
        row: theme.spacing.lgValue,
    },
};

export const gridBreakpointsUpcoming: GridBreakpoints = {
    breakpoints: {
        [theme.breakpoints.smMinValue]: {
            column: 4,
            gap: {
                column: theme.spacing.mdValue,
                row: theme.spacing.lgValue,
            },
        },
    },
    column: 1,
    gap: {
        column: theme.spacing.smValue,
        row: theme.spacing.lgValue,
    },
};

export const StyledItemGrid = styled(FluidItemGrid)`
    margin: 32px 0 16px;
`;
